import React from "react";
import { isMobile } from "react-device-detect";
class Banner extends React.Component {
    constructor(props) {
        super(props);

        const root = props.config.root.indexOf("http") === 0 ? props.config.root : configurationSettings.baseUrl + props.config.root;
        let path = props.src || (root + props.config[props.bannerId]);
        path = path.replace("-footer-multiples", "-footer-exchange");

        if (props.anchorPages && (GBEglobal.mode !== ModeTypes.Multiples) && GBEglobal.settings.fileManagerLocation !== undefined && GBEglobal.settings.fileManagerLocation.homepage) {
            path = this.getAnchorPageUrl() || path;
        }

        this.state = {
            bannerHtml: undefined,
            height: 0,
            visibility: "hidden",
            path: path
        };
        this.orientationChanged = this.orientationChanged.bind(this);
        this.getAnchorPageUrl = this.getAnchorPageUrl.bind(this);
        this.resizeBanner = this.resizeBanner.bind(this);
        this.checkVisibility = this.checkVisibility.bind(this);

        this.myRef = React.createRef();
        this.isInjectedBanner = true;
        this.contentRef = React.createRef();
    }

    resizeBanner() {
        const thisComponent = this;
        if (this.isInjectedBanner || thisComponent.myRef.current === null) {
            return;
        }
        thisComponent.myRef.current.contentWindow.postMessage(
            {
                event_id: "resizebanner",
                data: {
                    frameId: thisComponent.myRef.current.id
                }
            },
            "*" //or "www.parentpage.com"
        );
        thisComponent.myRef.current.contentWindow.postMessage(
            {
                event_id: "pagedetails",
                data: {
                    configurationSettings: configurationSettings,
                    url: window.location.href,
                    punter: window.getPunterDetails()
                }
            },
            "*" //or "www.parentpage.com"
        );

        window.setTimeout(function () {
            if (thisComponent.myRef.current !== null) {
                thisComponent.myRef.current.contentWindow.postMessage(
                    {
                        event_id: "resizebanner",
                        data: {
                            frameId: thisComponent.myRef.current.id
                        }
                    },
                    "*" //or "www.parentpage.com"
                );
            }
        }, 1000);

    }

    checkVisibility(instance) {
        //const thisComponent = this;
        //if banner not visible 5 seconds are loaidng remove it for SEO performance

        window.setTimeout(function () {
            if (instance !== null && instance.style.visibility === "hidden") {
                instance.parentElement.style.display = "none";
            }

        }, 5000);

    }

    orientationChanged() {
        const thisComponent = this;
        thisComponent.resizeBanner(thisComponent.myRef.current);
    }

    componentDidMount() {
        const thisComponent = this;
        //        Detect whether device supports orientationchange event, otherwise fall back to the resize event.
        var supportsOrientationChange = "onorientationchange" in window,
            orientationEvent = supportsOrientationChange ? "orientationchange" : "resize";
        window.addEventListener(orientationEvent, this.orientationChanged, false);
        if (thisComponent.resizeTimer !== undefined) {
            window.clearTimeout(thisComponent.resizeTimer);
        }
        const settings = this.props.config;
        if (this.props.src === undefined && (settings === undefined || settings[this.props.bannerId] === undefined)) {
            return;
        }
        const root = settings.root.indexOf("http") === 0 ? settings.root : configurationSettings.baseUrl + settings.root;
        const notFound = this.props.bannerId === "notfound";

        this.isInjectedBanner = settings.isAllInjected || notFound || (this.props.bannerId === "footer" && settings.isFooterInjected);
        if (this.isInjectedBanner) {
            const path = this.props.src || (root + settings[this.props.bannerId]);
            const hasQuery = path.indexOf("?") > -1;

            var userParam = this.props.userContext !== undefined ? "username=" + this.props.userContext.partnerUsername : "";
            var src = path + (hasQuery ? "&" : "?") + userParam;
            fetch(src).then(function (response) {
                // The API call was successful!
                if (response.ok) {
                    return response.text();
                } else {
                    //don;t keep loading the 404 page if it doesnt exist
                    if (window.location.href.indexOf("notfound") === -1) {
                        //    location.href = configurationSettings.baseUrl + configurationSettings.modes[0].toLowerCase() + "/notfound";
                    }
                }
            }).then(function (html) {
                // This is the HTML from our response as a text string
                var cdnFolder = path.substring(0, path.lastIndexOf("/") + 1);
                try {
                    var htmlDoc = document.createElement("html");
                    htmlDoc.innerHTML = html;
                    var titleTag = htmlDoc.getElementsByTagName("title");
                    if (titleTag !== null && titleTag.length > 0) {
                        document.title = titleTag[0].innerText;
                    }
                    var descriptionTag = htmlDoc.querySelector("meta[name='description']");
                    if (descriptionTag !== null && descriptionTag.content !== undefined) {
                        document.querySelector("meta[name='description']").setAttribute("content", descriptionTag.content);
                    }
                } catch (ex) {
                    console.error(ex.message);
                }
                html = html.replace(/src="(?!http|data:)/g, "src=\"" + cdnFolder);
                html = html.replace(/href="(?!http|javascript|#|data:)/g, "href=\"" + cdnFolder);
                if (notFound) {
                    const href = `${window.location.origin}/${configurationSettings.mode.toLowerCase() ?? ""}`;
                    html = html.replace(/href=".+"/g, "href=\"" + href + "\"");

                    // Some simple styles to add when on mobile
                    const styles = "width: 92%; margin-left: auto; margin-right: auto; margin-top: 1rem;";
                    html = isMobile ? html.replace(/styles=".+"/g, "style=\"" + styles + "\"") : html;
                }
                const newHtml = new DOMParser().parseFromString(html, "text/html");
                const head = newHtml.head.children;
                const nodesToRemove = [];
                for (const item of head) {
                    const nodeName = item.nodeName;
                    const removeNode = ["META", "TITLE"].includes(nodeName) || (nodeName === "LINK" && (item.href.indexOf("bootstrap.min.css") !== -1 || item.href.indexOf("fonts.googleapis.com/css") !== -1));
                    if (removeNode) {
                        nodesToRemove.push(item);
                    }
                }
                nodesToRemove.forEach((node) => {
                    newHtml.head.removeChild(node);
                });
                const htmlToInject = newHtml.head.innerHTML + newHtml.body.innerHTML;
                thisComponent.setState({
                    bannerHtml: htmlToInject
                }, function () {
                    Array.from(thisComponent.contentRef.current.querySelectorAll("script")).forEach((oldScript) => {
                        const newScript = document.createElement("script");
                        var addScript = false; //true when the class is
                        Array.from(oldScript.attributes)
                            .forEach((attr) => {
                                if (attr.name === "class" && attr.value.indexOf("GBET-execute") > -1) {
                                    addScript = true;
                                }
                                newScript.setAttribute(attr.name, attr.value);
                            });
                        if (addScript) {
                            newScript.appendChild(document.createTextNode(oldScript.innerHTML));
                            oldScript.parentNode.replaceChild(newScript, oldScript);
                        }
                    });
                });
            }).catch(function (err) {
                // There was an error
                console.warn("Something went wrong getting banner: " + thisComponent.props.bannerId, err);
            });
        }
    }

    componentDidUpdate() {
        const thisComponent = this;
        thisComponent.resizeBanner(thisComponent.myRef.current);
        const settings = this.props.config;

        const root = settings.root.indexOf("http") === 0 ? settings.root : configurationSettings.baseUrl + settings.root;
        let path = this.props.src || (root + settings[this.props.bannerId]);

        //multiples footer should use exchange footer
        path = path.replace("-footer-multiples", "-footer-exchange");

        if (this.props.isAnchorPage && (GBEglobal.mode !== ModeTypes.Multiples) && GBEglobal.settings.fileManagerLocation !== undefined && GBEglobal.settings.fileManagerLocation.homepage) {
            path = this.getAnchorPageUrl() || path;
        }

        if (path !== this.state.path) {
            this.setState({ path: path });
        }

    }

    componentWillUnmount() {
        window.clearTimeout(this.resizeTimer);
        var supportsOrientationChange = "onorientationchange" in window,
            orientationEvent = supportsOrientationChange ? "orientationchange" : "resize";
        window.removeEventListener(orientationEvent, this.orientationChanged);
    }

    getUrl(gameImg) {
        return "cdn/lobby-games/thumbs/" + gameImg;
    }

    getAnchorPageUrl() {
        const thisComponent = this;
        const fileManagerLocation = GBEglobal.settings.fileManagerLocation.homepage;
        let bannerName = thisComponent.props.isInPlayTab ? "inplaybanner" : undefined;
        let parentEvent;
        if (thisComponent.props.breadCrumbs && thisComponent.props.breadCrumbs.length) {
            const eventId = thisComponent.props.breadCrumbs[0].eventClassifierId;
            if (GBEglobal.settings.anchorPages?.[eventId]?.banner) {
                parentEvent = eventId;
            }
        }
        if (!thisComponent.props.isInPlayTab && parentEvent) {
            bannerName = parentEvent;
        }

        if (bannerName === undefined) {
            return undefined;
        }
        const newPath = fileManagerLocation + bannerName + ".html";
        return newPath;
    }

    render() {

        const frameId = GBEUtils.createUUID();

        const isRightNav = this.props.isRightNav ? "rightNavIframe" : "";
        const settings = this.props.config;
        if (this.props.src === undefined && (settings === undefined || settings[this.props.bannerId] === undefined)) {
            return (<div></div>);
        }

        if (this.isInjectedBanner && this.state.bannerHtml !== undefined) {
            return (
                <div ref={this.contentRef} dangerouslySetInnerHTML={{ __html: this.state.bannerHtml }} className={this.bodyClass}>
                </div >);
        }

        if (this.state.path === undefined) {
            return (<div></div>);
        }

        const hasQuery = this.state.path.indexOf("?") > -1;
        var segment = GBEUtils.getCookie("CustomMarketsSegmentPTV");
        var userParam = this.props.userContext !== undefined ? "isloggedin=true&currency=" + this.props.userContext.currency + "&countrycode=" + this.props.userContext.country + "&isIdentityEstablished=" + this.props.userContext.isIdentityEstablished + (segment !== "undefined" ? "&segment=" + segment : "") + "&gender=" + this.props.punterDetails.sex : "countrycode=" + window.serverData.countryCode;
        var src = this.state.path + (hasQuery ? "&" : "?") + userParam + "&priceformat=" + GBEglobal.priceFormat + "&currency=" + GBEglobal.currency + "&gamesAllowed=" + (this.props.isBlockedFromGames !== true) + "&ipaddress=" + window.serverData.ipAddress;
        return (<div className={this.props.bannerClass + " banner"}>
            <iframe title="banner" scrolling="no" name={isRightNav} ref={this.myRef} data-hj-allow-iframe="" id={frameId} src={src} onLoad={this.resizeBanner.bind(this)} style={{ "visibility": "visible" }}></iframe>
        </div>);
    }
}
export { Banner };